import { render, staticRenderFns } from "./Help-popin.vue?vue&type=template&id=31b5c405&scoped=true&"
import script from "./Help-popin.vue?vue&type=script&lang=js&"
export * from "./Help-popin.vue?vue&type=script&lang=js&"
import style0 from "./Help-popin.vue?vue&type=style&index=0&id=31b5c405&prod&scoped=true&lang=scss&"
import style1 from "./Help-popin.vue?vue&type=style&index=1&id=31b5c405&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31b5c405",
  null
  
)

export default component.exports